export class SearchTerm {
  searchValue: string;
  currentSearchValue: string;
  hasSearchTerm: boolean;

  defaultText = '';
  searchField: string;
  searchList: any[];

  constructor(field = '', placeholder = 'Search...' ) {
    this.searchValue = '';
    this.currentSearchValue = '';
    this.searchField = field;
    this.defaultText = placeholder;
    this.hasSearchTerm = false;
  }

  public clear() {
    this.searchValue = '';
    this.currentSearchValue = '';
    this.hasSearchTerm = false;
  }

  public save() {
    if (this.searchValue != null && this.searchValue != '') {
      this.currentSearchValue = this.searchValue;
      this.searchValue = '';
      this.hasSearchTerm = true;
    }
    else {
      this.searchValue = '';
      this.currentSearchValue = '';
      this.hasSearchTerm = false;
    }
  }

  public setSearchList(newList: any[]) {
    this.searchList = newList;
  }

  public searchInList(newList?: any[]) {
    if (newList != null) {
      this.searchList = newList;
    }

    return this.searchList
      .filter(x =>
        x[this.searchField].toLowerCase()
          .indexOf(this.currentSearchValue.toLowerCase(),
          ) !== -1);
  }
}
